import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DxDataGridModule } from 'devextreme-angular';
import { ContentReadyEvent } from 'devextreme/ui/data_grid';
import { FormListComponent } from '../components/utils/form-list/form-list.component';

@Component({
  selector: 'app-sat-referral-list',
  imports: [CommonModule, DxDataGridModule, FormListComponent],
  template: `<app-form-list
    form="SatReferral"
    header="Substance Abuse Treatment Referrals"
    detailUrl="/mdoc/sat-referral"
    (onContentReady)="contentReady($event)"
  ></app-form-list>`,
  styles: []
})
export class SatReferralListComponent {
  contentReady = (e: ContentReadyEvent) => {
    e.component.instance().columnOption('date', 'dataType', 'date');
  };
}
